import React from "react";
import { Box, Button, Container } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import AnimatedDemoComponent from "../components/AnimatedDemo";

const AnimatedDemoPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-tealLight/30 to-paper text-ink antialiased selection:bg-teal/20 selection:text-ink">
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 4 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/interactive-demo")}
            sx={{
              color: "#085041",
              "&:hover": { backgroundColor: "rgba(8,80,65,0.08)" },
            }}
          >
            Back to Interactive Demo
          </Button>
        </Box>

        <Box sx={{ mb: 4 }}>
          <div className="mb-2 inline-block">
            <div className="inline-flex items-center gap-2 rounded-full border border-teal/20 bg-tealLight px-3 py-1 text-xs font-semibold uppercase tracking-wider text-teal">
              Animated Demo
            </div>
          </div>

          <h1 className="text-3xl font-bold leading-tight tracking-tight text-teal sm:text-4xl lg:text-5xl">
            Animated CTF Demo
          </h1>

          <p className="mt-2 max-w-3xl text-base text-inkSoft">
            Watch a fully simulated patient-data workflow—from file selection and
            multimodal ingestion through CTF fusion and explainable AI.
          </p>
        </Box>

        <AnimatedDemoComponent />
      </Container>
    </div>
  );
};

export default AnimatedDemoPage;
